module.exports = __webpack_public_path__ + "static/media/gallery6.bef1280b.jpg";